import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import { getNotifications } from '../../store/general/selectors';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import './AdministratorDashboard.scss';
import { NotificationTypeEnum } from '../../models';
import { useCallback, useMemo } from 'react';
import { openEntity, openAppointment } from '../../store/entities/actions';
import { Notification } from '../../models';
import { getPackAsync } from '../../ajax/requests';
import { formatEuros } from '../../shared/string';

export const DebtorsTab = () => {
  const t = useTranslations()
  const dispatch = useDispatch()
  const notifications = useSelector(getNotifications)

  const missingPayment = useMemo(
    () => notifications.filter(n => [
        NotificationTypeEnum.AppointmentMissingPayment,
        NotificationTypeEnum.PackMissingPayment,
      ].includes(n.type)), 
    [notifications])

  const total = useMemo(() => missingPayment.reduce((prev, curr) => prev+(curr.value ? parseFloat(curr.value) : 0), 0), [missingPayment])

  const onClick = useCallback((notification: Notification) => () => {
    switch(notification.type) {
        case NotificationTypeEnum.AppointmentMissingPayment:
            dispatch(openAppointment(notification.entityId!));
            break;
        case NotificationTypeEnum.PackMissingPayment: 
            dispatch(openEntity('clientPacks', notification.entityId!, () => getPackAsync(notification.entityId!)));
            break;
    }
  }, []) 

  return (<>
    <h2><b>{t(TK.total)}:</b> {formatEuros(total)}</h2>
    <hr/>
    <div className="tableContainer">
      <Table striped>
        <thead>
            <th>{t(TK.date)}</th>
            <th>{t(TK.type)}</th>
            <th>{t(TK.value)}</th>
            <th>{t(TK.description)}</th>
        </thead>
        <tbody>
          {missingPayment.map((n, i) => (
              <tr key={i} onClick={onClick(n)} className="clickable">
                <td>{n.date}</td>
                <td>{n.type === NotificationTypeEnum.PackMissingPayment ? `${t(TK.pack)}/${t(TK.subscription)}` : t(TK.appointment)}</td>
                <td>{formatEuros(n.value)}</td>
                <td>{n.description}</td>
              </tr>
          ))}
        </tbody>
      </Table>
    </div>
  </>)
} 
